import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';


export const moduleTitle = 'PHLEBO';

export const tablePageSize = GLOBAL_TABLE_PAGE_SIZE;
export const drawerTitle = 'EXTRACTION';

export const tabNames = {
  forExtraction : 'FOR EXTRACTION',
  extracted: 'EXTRACTED'
}